import { render, staticRenderFns } from "./MessagesWidget.vue?vue&type=template&id=6c8e460c&scoped=true"
import script from "./MessagesWidget.vue?vue&type=script&lang=js"
export * from "./MessagesWidget.vue?vue&type=script&lang=js"
import style0 from "./MessagesWidget.vue?vue&type=style&index=0&id=6c8e460c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c8e460c",
  null
  
)

export default component.exports